import { useEffect } from 'react';

/**
 * usePageTitle - Sets the document title for SEO and accessibility.
 * Call this hook at the top of any page/route component.
 * 
 * @param title - The page title (will be suffixed with " | Thriveiti")
 * 
 * @example
 * usePageTitle('Dashboard');
 * // Sets document.title to "Dashboard | Thriveiti"
 */
export default function usePageTitle(title: string): void {
    useEffect(() => {
        const suffix = 'Thriveiti';
        document.title = title ? `${title} | ${suffix}` : suffix;

        return () => {
            // Reset on unmount if needed (optional)
        };
    }, [title]);
}
